var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFellowship(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#AF52DE",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1797_3164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2437 24.5561C22.4062 22.6936 22.4062 19.6686 24.2437 17.8061C26.0812 15.9436 29.0562 15.9436 30.8937 17.8061L32 18.9311L33.1063 17.8061C34.9438 15.9436 37.9188 15.9436 39.7563 17.8061C41.5938 19.6686 41.5938 22.6936 39.7563 24.5561L33.4062 31.0061C33.0187 31.3998 32.5125 31.5936 32 31.5936C31.4875 31.5936 30.9813 31.3998 30.5938 31.0061L24.2437 24.5561ZM49.5125 37.0186C50.3312 38.1311 50.0938 39.6936 48.9813 40.5123L41.0688 46.3436C39.6063 47.4186 37.8438 47.9998 36.025 47.9998H26H16C14.8937 47.9998 14 47.1061 14 45.9998V41.9998C14 40.8936 14.8937 39.9998 16 39.9998H18.3L21.1062 37.7498C22.525 36.6123 24.2875 35.9998 26.1062 35.9998H31H32H36C37.1063 35.9998 38 36.8936 38 37.9998C38 39.1061 37.1063 39.9998 36 39.9998H32H31C30.45 39.9998 30 40.4498 30 40.9998C30 41.5498 30.45 41.9998 31 41.9998H38.5375L46.0187 36.4873C47.1312 35.6686 48.6938 35.9061 49.5125 37.0186ZM26.1 39.9998H26.0437C26.0625 39.9998 26.0813 39.9998 26.1 39.9998Z",
    fill: "#AF52DE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1797_3164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 32,
    fill: "white",
    transform: "translate(14 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFellowship);
export default __webpack_public_path__ + "static/media/fellowship.be99577bc02a52832e05ca007226507a.svg";
export { ForwardRef as ReactComponent };